/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import * as Query from '../queries';
import decorateResponse from './decorateResponse';

export default async ({ type, resource, params, client }) => {
  let result;
  // example
  // if (resource === 'Configuration') {
  //   if (type === 'GET_ONE') {
  //     result = await Query.getOneConfig({ client, params });
  //   }
  //   if (type === 'UPDATE' || type === 'CREATE') {
  //     result = await Query.updateConfig({ client, params });
  //   }
  // }


  if (resource === 'Plot') {
    if (type === 'CREATE') {
      result = await Query.createPlot({ client, params });
    }
    if (type === 'UPDATE') {
      result = await Query.updatePlot({ client, params });
    }
  }

  if (resource === 'Evidence' && type === 'CREATE') {
    result = await Query.createEvidence({ client, params });
  }

  if (resource === 'Evidence' && type === 'UPDATE') {
    result = await Query.updateEvidence({ client, params });
  }

  if (resource === 'PlotEvidence' && type === 'UPDATE') {
    result = await Query.updatePlotEvidence({ client, params });
  }

  if (resource === 'Event' && type === 'CREATE') {
    result = await Query.createEvent({ client, params });
  }
  if (resource === 'Event' && type === 'UPDATE') {
    result = await Query.updateEvent({ client, params });
  }

  if (resource === 'EventEvidence' && type === 'CREATE') {
    result = await Query.createEventEvidence({ client, params });
  }
  if (resource === 'EventEvidence' && type === 'UPDATE') {
    result = await Query.updateEventEvidence({ client, params });
  }
  if (resource === 'EventSuperSleuth' && type === 'UPDATE') {
    result = await Query.awardSuperSleuth({ client, params });
  }

  if (resource === 'Location') {
    if (type === 'CREATE') {
      result = await Query.createLocation({ client, params });
    }
    if (type === 'UPDATE') {
      result = await Query.updateLocation({ client, params });
    }
  }

  return decorateResponse({
    type,
    resource,
    result,
  });
};
